<template>
  <div>
    <v-card class="pt-3 pb-3 mb-3">
      <v-row>
        <v-card-title>
          <h2 class="text-xl">Configs</h2>
          <!-- <dag-info :dags="['']" /> -->
        </v-card-title>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            class="ml-6 mr-6"
            v-model="search"
            :prepend-icon="icons.mdiMagnify"
            label="Recherche (par ...)"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-data-table
            class="ml-6 mr-6"
            :items="items"
            :headers="headers"
            :search="search"
          >
            <template v-slot:[`item.acqui_utm.source`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="truncate-cell" v-bind="attrs" v-on="on">
                    {{ item.acqui_utm.source }}
                  </div>
                </template>
                <span>{{ item.acqui_utm.source }}</span>
              </v-tooltip>
            </template>
            <template v-slot:[`item.acqui_utm.campaign`]="{ item }">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div class="truncate-cell" v-bind="attrs" v-on="on">
                    {{ item.acqui_utm.campaign }}
                  </div>
                </template>
                <span>{{ item.acqui_utm.campaign }}</span>
              </v-tooltip>
            </template>
            <template v-slot:item.edit="{ item }">
              <div>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="editConfig(item)"
                >
                  <v-icon color="primary">
                    {{ icons.mdiPencil }}
                  </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  elevation="0"
                  fab
                  small
                  @click="deleteConfig(item)"
                >
                  <v-icon color="secondary">
                    {{ icons.mdiTrashCan }}
                  </v-icon>
                </v-btn>
              </div>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>

    <v-dialog v-model="configDialog" max-width="600px">
      <v-card>
        <v-card-title>Modifier la config</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="config.name"
                label="Nom du groupe"
                outlined
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-select
                v-model="config.site.id"
                :items="sites"
                item-text="name"
                item-value="id"
                label="Sites"
                outlined
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-select
                v-model="config.acqui_platform.id"
                :items="platforms"
                item-text="name"
                item-value="id"
                label="Plateformes"
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="config.acqui_metric.id"
                :items="filteredMetrics"
                item-text="name"
                item-value="id"
                label="Métriques"
                outlined
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                v-model="config.acqui_utm.id"
                :items="filteredUtms"
                :item-text="utmText"
                item-value="id"
                label="Utms"
                outlined
                hide-details
              ></v-select>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="primary" @click="updateConfig">Enregistrer</v-btn>
          <v-btn color="secondary" @click="cancelconfig">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>
.truncate-cell {
  max-width: 150px; /* Limite la largeur de la cellule */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer; /* Indique que l'utilisateur peut interagir */
}
</style>

<script>
import DagInfo from "@/components/common/menus/DagInfo";
import useAxios from "@/hooks/useAxios";
import debounce from "lodash/debounce";
import { mdiPencil, mdiTrashCan, mdiMagnify } from "@mdi/js";

export default {
  name: "dailyReportConfigTable",
  components: {},

  data() {
    return {
      search: "",
      items: [],
      headers: [
        { text: "Nom", value: "name" },
        { text: "Site", value: "site.name" },
        { text: "Platform", value: "acqui_platform.name" },
        { text: "Metric", value: "acqui_metric.name" },
        { text: "Utm source", value: "acqui_utm.source" },
        { text: "Utm campaign", value: "acqui_utm.campaign" },
        { text: "Edit", value: "edit" },
      ],
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiMagnify,
      },
      configDialog: false,
      config: {
        id: "",
        name: "",
        acqui_platform: { id: "" },
        acqui_metric: { id: "" },
        acqui_utm: { id: "" },
        site: { id: "" },
      },
      platforms: [],
      metrics: [],
      utms: [],
      sites: [],
      filteredMetrics: [],
      filteredUtms: [],
    };
  },

  setup() {
    const { axiosGet, axiosPost, axiosPut, axiosDelete, isLoading } =
      useAxios();

    return {
      axiosGet,
      isLoading,
      axiosPost,
      axiosPut,
      axiosDelete,
    };
  },

  methods: {
    utmText(item) {
      const truncate = (str) =>
        str.length > 10 ? str.slice(0, 10) + "..." : str;
      const source = truncate(item.source || "");
      const campaign = truncate(item.campaign || "");
      return `${source} / ${campaign}`;
    },
    debouncedUpdateData: debounce(async function () {
      await this.getData();
    }, 500),
    async getPlatforms() {
      const response = await this.axiosGet("/acquisition/platform/");
      this.platforms = response.data;
      this.$store.commit("acquisition/setPlatforms", this.platforms);
    },
    async getMetrics() {
      const response = await this.axiosGet("/acquisition/metric/");
      this.metrics = response.data;
      this.$store.commit("acquisition/setMetrics", this.metrics);
    },
    async getUtms() {
      const response = await this.axiosGet("/acquisition/utm/");
      this.utms = response.data;
      this.$store.commit("acquisition/setUtms", this.utms);
    },
    async getData() {
      const response = await this.axiosGet("/acquisition/config/");
      this.items = response.data;
      console.log("items", this.items);
    },
    async getSites() {
      const response = await this.axiosGet("/sites/");
      this.sites = response.data.items;
      this.$store.commit("acquisition/setSites", this.sites);
    },
    async cancelconfig() {
      this.configDialog = false;
      this.getData();
    },
    async editConfig(item) {
      this.config = item;
      await this.updateFilteredOptions();
      this.configDialog = true;
    },
    async updateConfig() {
      const params = {
        name: this.config.name,
        acqui_platform_id: this.config.acqui_platform.id,
        acqui_metric_id: this.config.acqui_metric.id,
        acqui_utm_id: this.config.acqui_utm.id,
        site_id: this.config.site.id,
      };

      if (
        !params.name ||
        !params.acqui_platform_id ||
        !params.acqui_metric_id ||
        !params.acqui_utm_id ||
        !params.site_id
      ) {
        alert("Merci de remplir tous les champs.");
        return;
      }
      try {
        await this.axiosPut(`/acquisition/config/${this.config.id}`, params);
      } catch (error) {
        console.error("Error saving UTM:", error);
        alert(
          "Erreur lors de la création de l'UTM, Vérifier l'inetégrité des données (doublons). Si les données sont intègres utilisez l'outil de report d'erreur"
        );
        this.cancelUtm();
      }
      this.configDialog = false;
      this.getData();
    },
    async deleteConfig(item) {
      this.config = item;
      await this.axiosDelete(`/acquisition/config/${this.config.id}`);
      this.getData();
    },
    async updateFilteredOptions() {
      if (this.config.acqui_platform.id) {
        this.filteredMetrics = await this.$store.dispatch(
          "acquisition/updateFilteredMetrics",
          this.config.acqui_platform.id
        );
        this.filteredUtms = await this.$store.dispatch(
          "acquisition/updateFilteredUtms",
          this.config.acqui_platform.id
        );
      } else {
        this.filteredMetrics = [];
        this.filteredUtms = [];
      }
    },
  },

  async created() {
    await this.getPlatforms();
    await this.getMetrics();
    await this.getUtms();
    await this.getData();
    await this.getSites();
  },
  computed: {},
  watch: {
    "config.acqui_platform.id": "updateFilteredOptions",
  },
};
</script>
